export enum Material {
    Aluminium = "aluminium",
    Copper = "copper",
    Gold = "gold",
}